<rect
    x="0.666667"
    y="0.666667"
    width="48.6667"
    height="48.6667"
    rx="24.3333"
    stroke="#E6E8EC"
    stroke-width="1.33333"
/>
<g clip-path="url(#clip0_438_119894)">
    <path
        d="M26.7191 23.3154L34.6753 14H32.7896L25.8831 22.0881L20.3643 14H14L22.3443 26.232L14 36H15.8857L23.1803 27.4577L29.0087 36H35.373L26.7191 23.3154ZM24.1373 26.3389L23.2919 25.121L16.5646 15.43H19.4607L24.8884 23.251L25.7339 24.4689L32.7911 34.636H29.895L24.1373 26.3389Z"
        fill="#777E90"
    />
</g>
<defs>
    <clipPath id="clip0_438_119894">
        <rect
            width="22"
            height="22"
            fill="white"
            transform="translate(14 14)"
        />
    </clipPath>
</defs>
